// extracted by mini-css-extract-plugin
export default {"input":"Footer_input__l5TaZ","Button":"Footer_Button__hoGVc"};